const headerStyle = theme => ({
    actionItemButton: { marginLeft: theme.spacing(4) },
    actionItemLabel: { marginLeft: theme.spacing(1), width: 'max-content' },
    actionItemIcon: { color: theme.palette.primary.main },
    statusChangeButton: { marginLeft: theme.spacing(2) },
});

export default headerStyle;
